import { skipToken } from '@tanstack/react-query';
import { useState } from 'react';
import { formatDatetime } from '../utils/fieldFormats.ts';
import { trpc } from '../utils/trpc/trpc.ts';
import { ModalDialog } from './modalDialog.tsx';


interface Props {
    isOpen: boolean,
    // measurementType: MeasurementType,
    // equipment?: string,
    // onRecordCreated: (record: Record) => void,
    pendingProtocolId?: string,
    onProtocolSelect: (protocolId: string) => void,
    onClose: () => void,
}

export function ProtocolSelectDialog({
    isOpen,
    // measurementType,
    // equipment,
    // onRecordCreated,
    pendingProtocolId,
    onProtocolSelect,
    onClose,
}: Props) {

    const [filter, setFilter] = useState('');


    const { data: protocols, isLoading } = trpc.protocols.get.useQuery(
        isOpen ? {
            isDisabled: false,
            sort: { partDisplayName: 1 },
        } : skipToken,
    );

    // const createIoqcRecord = trpc.records.createDraft.useMutation();
    // const createMIntRecord = trpc.measureInterval.createMeasurement.useMutation();
    //     {
    //     onSuccess: (record) => {
    //         onRecordCreated(record);
    //         onClose();
    //     },
    //     onError: (err) => {
    //         console.error(err);
    //         alert('Failed to create record');
    //     },
    // });


    const filteredProtocols = filter
        ? protocols?.filter(it => {
            const query = filter.toLowerCase().trim();
            return it.partDisplayName.toLowerCase().includes(query)
                || it.programs.some(it => it.toLowerCase().includes(query))
        })
        : protocols;


    // const handleProtocolSelected = async (protocolId: string) => {
    //     // if (recordDraftMutation.isPending || recordDraftMutation.isSuccess) return;
    //     // recordDraftMutation.mutate({
    //     //     measurementType,
    //     //     protocolId,
    //     // });
    //     if (createIoqcRecord.isPending || createIoqcRecord.isSuccess) return;
    //     if (createMIntRecord.isPending || createMIntRecord.isSuccess) return;
    //     try {
    //         let record;
    //         if (measurementType === 'ioqc') {
    //             record = await createIoqcRecord.mutateAsync({
    //                 protocolId,
    //                 measurementType: 'ioqc',
    //             })
    //         } else {
    //             if (!equipment) {
    //                 throw new Error('Equipment is required for measurement interval records');
    //             }
    //             const result = await createMIntRecord.mutateAsync({
    //                 equipment: equipment!,
    //                 product: null,
    //                 protocolId,
    //             });
    //             record = result.record!;
    //         }
    //         onRecordCreated(record);
    //         onClose();
    //     } catch (err) {
    //         reportError(err);
    //         alert('Failed to create record');
    //     }
    // }


    // const selectedProtocol = createIoqcRecord.variables?.protocolId ?? createMIntRecord.variables?.protocolId;

    return (
        <ModalDialog
            isOpen={isOpen}
            cancelOnOutsideClick={true}
            onCancel={onClose}
        >
            <div style={{ paddingBottom: '8px' }}>
                <span>Filter: </span>
                <input
                    type='text'
                    value={filter}
                    onChange={e => setFilter(e.target.value)}
                />
            </div>

            {isLoading
                ? <p>Loading protocols...</p>
                : <table className='table--protocol-selection'>
                    <thead>
                        <tr>
                            <th>Target</th>
                            <th>Version</th>
                            <th>Date created</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        {filteredProtocols?.map(it =>
                            <tr key={it._id}>
                                <td>{it.partDisplayName}</td>
                                <td>{it.version}</td>
                                <td>{formatDatetime(it.createTime)}</td>
                                <td>
                                    <button
                                        onClick={() => onProtocolSelect(it._id!)}
                                        children={it._id === pendingProtocolId ? 'Adding...' : 'Measure'}
                                    />
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            }
        </ModalDialog>
    );
}
